import { render, staticRenderFns } from "./modalAsignacionAreas.vue?vue&type=template&id=29145108&"
import script from "./modalAsignacionAreas.vue?vue&type=script&lang=js&"
export * from "./modalAsignacionAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports